/* eslint-disable react-hooks/exhaustive-deps */
import {
  Box,
  Button,
  Card,
  CardContent,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  List,
  ListItem,
  Tab,
  Tabs,
  Typography,
} from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import ChevronLeftOutlinedIcon from "@mui/icons-material/ChevronLeftOutlined";
import { useNavigate, useLocation } from "react-router-dom";
import WorkIcon from "@mui/icons-material/Work";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import ModeEditIcon from "@mui/icons-material/ModeEdit";
import PauseCircleOutlineIcon from "@mui/icons-material/PauseCircleOutline";
import PlayCircleIcon from "@mui/icons-material/PlayCircle";
import DeleteConfirmationDialog from "../../components/Composables/DeleteDialogs";
import API from "../../Utils/Interceptor/ApiMiddleware";
import formatters from "../../components/Composables/DataGridFormatters";
import DynamicDataGrid from "../../components/Composables/DynamicDataGrid";
import { convert } from "html-to-text";
import AddJob from "./AddJob";
import CustomSnackbar from "../../components/Composables/CustomSnackBarMenu";
import LoadingSpinner from "../../components/Composables/CircularProgressBar";
import ShortlistedDialog from "./ShortlistedDialog";

export default function JobDescription() {
  const [backbutton, setbackbutton] = useState(false);
  const navigate = useNavigate();
  const [dialog, setDialog] = useState(false);
  const [selectedTab, setSelectedTab] = useState("JobInfo");
  const [editJobDialog, setEditJobDialog] = useState(false);
  const [pauseDialog, setPauseDialog] = useState(false);
  const [shortlistId, setShortlistId] = useState(null);
  const [shortlistedDialog, setShortlistedDialog] = useState(false);
  const [candidateData, setCandidateData] = useState([]);
  const [sourceType, setSourceType] = useState(null);
  const [tabValue, setTabValue] = useState("CandidateInfo");
  const [dateModified, setDateModified] = useState(null);
  const [status, setStatus] = useState(null);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "error",
  });
  const [loading, setLoading] = useState(false);
  const [employerData, setEmployerData] = useState({
    countData: [],
    shortlistedData: [],
    applicantsData: [],
    paginationModel: {
      pageSize: 25,
      page: 0,
    },
  });
  const [jobData, setJobData] = useState({});
  const [questionsData, setQuestionsData] = useState([]);
  const questionsType = ["Descriptive", "Numeric", "Yes/No"];
  const location = useLocation();
  const jobId = location?.state?.id;

  useEffect(() => {
    fetchJobDetails();
    fetchJobApplicantsDetails();
    fetchJobShortlistedDetails();
    getQuestionsData();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
  const fetchCandidateData = async () => {
    if (!shortlistId) return;

    // setLoading(true);
    try {
      const response = await API.get(
        `/user/get-user-profile-details/${shortlistId}`,
        {
          params: { pageName: "job popup", jobId },
        }
      );
      setCandidateData(response.data.data);
    } catch (error) {
      console.error("Error fetching candidate data:", error.message);
    } finally {
      // setLoading(false);
    }
  };

  // There is also an alias to `convert` called `htmlToText`.

  // const options = {
  //   wordwrap: 130,
  //   // ...
  // };

  const [showMore, setShowMore] = useState(false);
  const [isOverflowing, setIsOverflowing] = useState(false);
  const descriptionRef = useRef(null);

  const toggleShowMore = () => setShowMore((prev) => !prev);

  useEffect(() => {
    if (descriptionRef.current && !showMore) {
      const el = descriptionRef.current;
      setTimeout(() => {
        setIsOverflowing(el.scrollHeight > el.clientHeight);
      }, 0);
    }
  }, [jobData?.otherDetails?.description, showMore]);

  const handleShortlistedRowSelection = (row, sourceType) => {
    setShortlistId(row?.id);
    setCandidateData(row);
    setSourceType(sourceType);
    setShortlistedDialog(true);
    setDateModified(row?.date_modified);
    setStatus(row?.status);
  };

  const submittedQuestions = async (row) => {
    try {
      const response = await API.get(
        `/job/all-ques-ans/${row?.id}/jobId/${jobId}`
      );
      if (response?.data?.success) {
        console.log("questionsData", response?.data?.data);
      }
    } catch (error) {
      console.error("Error fetching job details", error);
    }
  };

  useEffect(() => {
    if (shortlistedDialog && shortlistId) {
      fetchCandidateData();
    }
  }, [shortlistedDialog, shortlistId]);

  const closeShortlistedDialog = () => {
    setShortlistedDialog(false);
    setTabValue("CandidateInfo");
  };

  const fetchJobDetails = async () => {
    setLoading(true);
    try {
      let jobId = location?.state?.id;
      const response = await API.get(`/job/get-job-details/${jobId}`);
      if (response?.data?.success) {
        const res = response?.data?.data?.job_details;

        // Converting HTML to Text for description
        res.otherDetails.description = convert(
          res?.otherDetails?.description ? res?.otherDetails?.description : "NA"
          // options
        );

        setJobData(response?.data?.data?.job_details);
      }
    } catch (error) {
      console.error("Error fetching job details", error);
    } finally {
      setLoading(false);
    }
  };
  const getQuestionsData = async () => {
    try {
      const response = await API.get(`/job/question-list-job/${jobId}`);
      if (response?.data?.success) {
        setQuestionsData(response?.data?.data);
        console.log("questionsData", response?.data?.data);
      }
    } catch (error) {}
  };

  const fetchJobApplicantsDetails = async () => {
    let jobId = location?.state?.id;
    const payload = {
      isShortlisted: 1,
      jobId,
      // search: "",
      // sortField,
      // sortBy,
      rowLimit: 25,
      pageNo: 1,
    };

    try {
      const response = await API.post("job/get-job-applicants", payload);
      const apiData = response.data.data;

      setEmployerData((prevState) => ({
        ...prevState,
        shortlistedData: apiData.data,
      }));
    } catch (error) {
      console.error("Error fetching job applicants details: ", error);
    }
  };

  const fetchJobShortlistedDetails = async () => {
    const payload = {
      isShortlisted: 0,
      jobId,
      // search: "",
      // sortField,
      // sortBy,
      rowLimit: 25,
      pageNo: 1,
    };

    try {
      const response = await API.post("job/get-job-applicants", payload);
      const apiData = response.data.data;
      const newApplicants = apiData.data;
      setEmployerData((prevState) => ({
        ...prevState,
        applicantsData: newApplicants,
      }));

      if (shortlistId) {
        const updatedCandidate = newApplicants.find(
          (item) => item.id === shortlistId
        );
        if (updatedCandidate) {
          setCandidateData(updatedCandidate);
          setDateModified(updatedCandidate.date_modified);
          setStatus(updatedCandidate.status);
        }
      }
    } catch (error) {
      console.error("Error fetching job applicants details: ", error);
    }
  };

  const handlePauseJob = async () => {
    try {
      const response = await API.post("/job/pause-resume-job", {
        job_id: jobId,
        status:
          jobData?.["basicDetails"]?.Status === "Active" ? "On Hold" : "Active",
        original_date_modified: jobData?.otherDetails?.originalDateModified,
      });
      if (response?.data?.success) {
        setPauseDialog(false);
        setSnackbar({
          open: true,
          message: `Job ${
            jobData?.basicDetails?.Status === "Active" ? "paused" : "resumed"
          } successfully`,
          severity: "success",
        });
        setTimeout(() => {
          fetchJobDetails();
        }, 1000);
      }
    } catch (error) {
      console.error("Error pausing job: ", error);
      setPauseDialog(false);
      setSnackbar({
        open: true,
        message: `Failed to ${
          jobData?.basicDetails?.Status === "Active" ? "pause" : "resume"
        } job`,
        severity: "error",
      });
    }
  };
  // useEffect(() => {
  //   if (selectedTab === "Shortlisted") {
  //     fetchJobApplicantsDetails();
  //   }
  // }, [selectedTab]);

  // useEffect(() => {
  //   if (selectedTab === "Applicants") {
  //     fetchJobApplicantsDetail();
  //   }
  // }, [selectedTab]);
  const handleDeleteConfirmation = async (confirmed) => {
    setDialog(false);
    if (confirmed) {
      try {
        await deleteCompanyFunction();
      } catch (error) {
        console.error("Error deleting company:", error);
      }
    }
  };

  const deleteCompanyFunction = async () => {
    try {
      const response = await API.post(`/job/delete-job/${jobId}`);
      if (response?.data?.success) {
        setSnackbar({
          open: true,
          message: "Job deleted successfully",
          severity: "success",
        });
        setTimeout(() => {
          // handleClose();
          navigate(-1);
        }, 2000);
      }
    } catch (error) {
      console.error("Error deleting company:", error);
      setSnackbar({
        open: true,
        message: "Error deleting company",
        severity: "error",
      });
    }
  };

  return (
    <Box
      sx={{
        padding: "16px",
        backgroundColor: "#E3F2FD",
        height: "100%",
        borderRadius: "24px 0 0 0",
      }}
    >
      <Box
        sx={{
          backgroundColor: "#FFF",
          padding: "16px",
          borderRadius: "12px",
          display: "flex",
          flexDirection: "column",
          height: "100%",
        }}
      >
        {loading ? (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "100%",
            }}
          >
            <LoadingSpinner />
          </Box>
        ) : (
          <>
            {/* Header */}
            <Box
              sx={{
                display: "flex",
                borderBottom: "1px solid rgba(21, 29, 72, 0.12)",
                paddingBottom: "16px",
                marginBottom: "16px",
                gap: "12px",
                alignItems: "center",
                flexShrink: 0,
              }}
            >
              <Button
                startIcon={
                  <ChevronLeftOutlinedIcon
                    style={{ height: "16px", width: "16px" }}
                  />
                }
                sx={{
                  "& .MuiButton-startIcon": backbutton
                    ? { marginRight: "4px !important" }
                    : { margin: "0px" },
                }}
                style={
                  backbutton
                    ? {
                        backgroundColor: "#3F95EA",
                        color: "white",
                        height: "24px",
                        fontSize: "12px",
                        textTransform: "none",
                      }
                    : {
                        backgroundColor: "#E7E7E7",
                        color: "#1A1A1A",
                        minWidth: "24px",
                        height: "24px",
                        padding: "4px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }
                }
                onMouseEnter={() => setbackbutton(true)}
                onMouseLeave={() => setbackbutton(false)}
                onClick={() => navigate(-1)}
              >
                {backbutton ? "Back" : ""}
              </Button>
              <Typography sx={{ fontSize: "22px", fontWeight: 600 }}>
                Job Details
              </Typography>
            </Box>

            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                flexShrink: 0,
              }}
            >
              <Box sx={{ display: "flex", gap: "16px", alignItems: "center" }}>
                <Box
                  sx={{
                    width: "100px",
                    height: "100px",
                    backgroundColor: "#E3F2FD",
                    borderRadius: "8px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  {jobData?.otherDetails?.companyLogo ? (
                    <img
                      src={`${process.env.REACT_APP_BASEURL}${jobData?.otherDetails?.companyLogo}`}
                      alt="Company Logo"
                      style={{
                        width: "100px",
                        height: "100px",
                        objectFit: "contain",
                        borderRadius: "8px",
                      }}
                    />
                  ) : (
                    <WorkIcon sx={{ fontSize: "100px", color: "#979797" }} />
                  )}
                </Box>

                <Box>
                  <Typography sx={{ fontSize: "20px", fontWeight: 600 }}>
                    {/* Job Title */}
                    {jobData?.basicDetails?.["Job Title"]}
                  </Typography>
                  <Typography sx={{ fontSize: "14px", fontWeight: 600 }}>
                    {/* Company Name */}
                    {jobData?.otherDetails?.companyName}
                  </Typography>
                  <Typography sx={{ fontSize: "14px", color: "#00000099" }}>
                    {/* Job Location */}
                    {jobData?.basicDetails?.Location}
                  </Typography>
                </Box>
              </Box>

              <Box>
                <Button
                  variant="outlined"
                  sx={{ marginRight: "16px" }}
                  startIcon={<ModeEditIcon />}
                  onClick={() => setEditJobDialog(true)}
                >
                  EDIT
                </Button>
                <Button
                  variant="outlined"
                  color={
                    jobData?.basicDetails?.Status === "Active"
                      ? "warning"
                      : "success"
                  }
                  sx={{ marginRight: "16px" }}
                  startIcon={
                    jobData?.basicDetails?.Status === "Active" ? (
                      <PauseCircleOutlineIcon />
                    ) : (
                      <PlayCircleIcon />
                    )
                  }
                  onClick={() => setPauseDialog(true)}
                >
                  {jobData?.basicDetails?.Status === "Active"
                    ? "PAUSE"
                    : "RESUME"}
                </Button>
                <Dialog
                  open={pauseDialog}
                  onClose={() => setPauseDialog(false)}
                >
                  <DialogTitle>{"Pause Job"}</DialogTitle>
                  <DialogContent>
                    <DialogContentText>
                      Are you sure you want to{" "}
                      {jobData?.basicDetails?.Status === "Active"
                        ? "pause"
                        : "resume"}{" "}
                      this job?
                    </DialogContentText>
                  </DialogContent>
                  <DialogActions>
                    <Button
                      onClick={() => setPauseDialog(false)}
                      color="inherit"
                    >
                      Cancel
                    </Button>
                    <Button
                      onClick={() => {
                        handlePauseJob();
                      }}
                      color="primary"
                      variant="contained"
                    >
                      OK
                    </Button>
                  </DialogActions>
                </Dialog>
                <Button
                  startIcon={<DeleteOutlineOutlinedIcon />}
                  variant="outlined"
                  color="error"
                  onClick={() => setDialog(true)}
                >
                  DELETE
                </Button>
              </Box>
            </Box>

            {/* Tabs */}
            <Box sx={{ flexShrink: 0 }}>
              <Tabs
                value={selectedTab}
                onChange={(e, newValue) => setSelectedTab(newValue)}
                style={{
                  margin: "16px 0px",
                  borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
                }}
                sx={{
                  "& .MuiTabs-indicator": {
                    height: "2px",
                  },
                }}
              >
                <Tab
                  value="JobInfo"
                  label="Job Info"
                  sx={{ fontWeight: "500", fontSize: "14px" }}
                />
                <Tab
                  value="Shortlisted"
                  label="Shortlisted"
                  sx={{ fontWeight: "500", fontSize: "14px" }}
                />
                <Tab
                  value="Applicants"
                  label="Applicants"
                  sx={{ fontWeight: "500", fontSize: "14px" }}
                />
              </Tabs>
            </Box>

            {/* Tab Content */}
            <Box sx={{ flexGrow: 1, overflow: "hidden" }}>
              {selectedTab === "JobInfo" && (
                <Box
                  sx={{
                    display: "flex",
                    width: "100%",
                    gap: "16px",
                    height: "100%",
                  }}
                >
                  <Card
                    elevation={0}
                    sx={{
                      borderRadius: "4px",
                      border: "1px solid rgba(115, 119, 145, 0.08)",
                      width: "100%",
                      display: "flex",
                      flexDirection: "column",
                      height: "100%",
                      overflow: "hidden",
                    }}
                  >
                    <Box
                      sx={{
                        borderRadius: "4px 4px 0 0",
                        padding: "14px 20px",
                        backgroundColor: "rgba(63, 149, 234, 0.20)",
                        color: "#000",
                        fontSize: "14px",
                        fontWeight: "600",
                        flexShrink: 0,
                      }}
                    >
                      Basic Details
                    </Box>
                    <CardContent
                      sx={{
                        padding: "16px 20px",
                        overflowY: "auto",
                        flexGrow: 1,
                      }}
                    >
                      {Object.keys(jobData).length > 0
                        ? Object.entries(jobData?.basicDetails).map(
                            ([key, value]) => (
                              <Box
                                key={key}
                                sx={{ marginBottom: "8px" }}
                                display={{
                                  xs: "block",
                                  md: "block",
                                  lg: "flex",
                                }}
                              >
                                <Typography
                                  sx={{
                                    textTransform: "capitalize",
                                    fontWeight: "400",
                                    fontSize: "14px",
                                    color: "rgba(0, 0, 0, 0.60)",
                                    width: "140px",
                                    marginRight: "20px",
                                    flexShrink: "0",
                                  }}
                                >
                                  {key}
                                </Typography>
                                <Typography
                                  sx={{
                                    fontWeight: "400",
                                    fontSize: "14px",
                                    color: "rgba(0, 0, 0, 0.87)",
                                  }}
                                >
                                  {value || "NA"}
                                </Typography>
                              </Box>
                            )
                          )
                        : "No Data Available"}
                    </CardContent>
                  </Card>

                  <Card
                    elevation={0}
                    sx={{
                      borderRadius: "4px",
                      border: "1px solid rgba(115, 119, 145, 0.08)",
                      width: "100%",
                      display: "flex",
                      flexDirection: "column",
                      height: "100%",
                      overflow: "hidden",
                    }}
                  >
                    <Box
                      sx={{
                        borderRadius: "4px 4px 0 0",
                        padding: "14px 20px",
                        backgroundColor: "rgba(63, 149, 234, 0.20)",
                        color: "#000",
                        fontSize: "14px",
                        fontWeight: "600",
                        flexShrink: 0,
                      }}
                    >
                      Other Details
                    </Box>
                    <CardContent
                      sx={{
                        padding: "16px 20px",
                        overflowY: "auto",
                        flexGrow: 1,
                      }}
                    >
                      <Typography
                        sx={{
                          fontSize: "14px",
                          fontWeight: "600",
                          marginBottom: "6px",
                          color: "rgba(0, 0, 0, 0.87)",
                        }}
                      >
                        Description
                      </Typography>

                      <Typography
                        ref={descriptionRef}
                        sx={{
                          fontSize: "14px",
                          fontWeight: "400",
                          color: "rgba(0, 0, 0, 0.87)",
                          display: "-webkit-box",
                          WebkitBoxOrient: "vertical",
                          WebkitLineClamp: showMore ? "unset" : 4,
                          overflow: "hidden",
                        }}
                      >
                        {jobData?.otherDetails?.description || "N/A"}
                      </Typography>

                      {(isOverflowing || showMore) && (
                        <Typography
                          onClick={toggleShowMore}
                          sx={{
                            cursor: "pointer",
                            color: "#3f95ea",
                            fontSize: "14px",
                            fontWeight: "500",
                            marginTop: "8px",
                            marginBottom: "12px",
                          }}
                        >
                          {showMore ? "Read less" : "Read more"}
                        </Typography>
                      )}

                      <Divider sx={{ margin: "12px 0" }} />

                      <Typography
                        sx={{
                          fontSize: "14px",
                          fontWeight: "600",
                          marginBottom: "6px",
                          color: "rgba(0, 0, 0, 0.87)",
                        }}
                      >
                        Skills
                      </Typography>

                      <Box
                        sx={{ display: "flex", flexWrap: "wrap", gap: "8px" }}
                      >
                        {jobData?.otherDetails?.skills
                          ?.split(",")
                          .map((skill, index) => (
                            <Box
                              key={index}
                              sx={{
                                fontSize: "12px",
                                padding: "4px 10px",
                                backgroundColor: "#E3F2FD",
                                borderRadius: "16px",
                                color: "#333",
                              }}
                            >
                              {skill.trim()}
                            </Box>
                          ))}
                      </Box>
                      {questionsData.length > 0 && (
                        <Box>
                          <Divider sx={{ margin: "12px 0" }} />

                          <Typography
                            sx={{
                              fontSize: "14px",
                              fontWeight: "600",
                              marginBottom: "6px",
                              color: "rgba(0, 0, 0, 0.87)",
                            }}
                          >
                            Screening Questions
                          </Typography>

                          <List
                            component="ol"
                            sx={{
                              display: "flex",
                              flexDirection: "column",
                            }}
                          >
                            {questionsData.map((question, index) => (
                              <ListItem
                                key={question.question_id || index}
                                disableGutters
                                sx={{ display: "block", pl: 0 }}
                              >
                                <Typography variant="body2">
                                  {index + 1}.{" "}
                                  {questionsType[question.question_type - 1]}{" "}
                                  question.
                                </Typography>
                                <Typography
                                  sx={{ fontWeight: 600, mt: 0.5, pl: 2 }}
                                >
                                  {question.question}
                                </Typography>
                              </ListItem>
                            ))}
                          </List>
                        </Box>
                      )}
                    </CardContent>
                  </Card>

                  <Card
                    elevation={0}
                    sx={{
                      borderRadius: "4px",
                      border: "1px solid rgba(115, 119, 145, 0.08)",
                      width: "100%",
                      display: "flex",
                      flexDirection: "column",
                      height: "100%",
                      overflow: "hidden",
                    }}
                  >
                    <Box
                      sx={{
                        borderRadius: "4px 4px 0 0",
                        padding: "14px 20px",
                        backgroundColor: "rgba(63, 149, 234, 0.20)",
                        color: "#000",
                        fontSize: "14px",
                        fontWeight: "600",
                        flexShrink: 0,
                      }}
                    >
                      Internal Notes
                    </Box>
                    <CardContent
                      sx={{
                        padding: "16px 20px",
                        overflowY: "auto",
                        flexGrow: 1,
                        display: "flex",
                        flexDirection: "column",
                        alignItems: jobData?.otherDetails?.notes
                          ? "flex-start"
                          : "center",
                        justifyContent: jobData?.otherDetails?.notes
                          ? "flex-start"
                          : "center",
                      }}
                    >
                      <Typography
                        sx={{
                          fontSize: "14px",
                          fontWeight: jobData?.otherDetails?.notes ? 400 : 700,
                          color: "text.secondary",
                          textAlign: jobData?.otherDetails?.notes
                            ? "left"
                            : "center",
                        }}
                      >
                        {jobData?.otherDetails?.notes
                          ? jobData.otherDetails.notes
                          : "No notes found"}
                      </Typography>
                    </CardContent>
                  </Card>
                </Box>
              )}
              {selectedTab === "Shortlisted" && (
                <Box
                  sx={{
                    backgroundColor: "#FFF",
                    borderRadius: "4px",
                    height: "100%",
                    overflow: "hidden",
                  }}
                >
                  <DynamicDataGrid
                    rows={employerData.shortlistedData}
                    showCheckbox={false}
                    name={"Shortlisted"}
                    onRowSelection={(row) =>
                      handleShortlistedRowSelection(row, "Shortlisted")
                    }
                    formatters={formatters}
                    totalRows={employerData.shortlistedData?.length || 0}
                    paginationModel={employerData.paginationModel}
                    onPaginationModelChange={(newPaginationModel) => {
                      setEmployerData((prevState) => ({
                        ...prevState,
                        paginationModel: newPaginationModel,
                      }));
                    }}
                  />
                </Box>
              )}

              {selectedTab === "Applicants" && (
                <Box
                  sx={{
                    backgroundColor: "#FFF",
                    borderRadius: "4px",
                    height: "100%",
                    overflow: "hidden",
                  }}
                >
                  <DynamicDataGrid
                    rows={employerData.applicantsData}
                    showCheckbox={false}
                    name={"Applicants"}
                    onRowSelection={(row) => {
                      handleShortlistedRowSelection(row, "Applicants");
                      submittedQuestions(row);
                    }}
                    formatters={formatters}
                    totalRows={employerData.applicantsData?.length || 0}
                    paginationModel={employerData.paginationModel}
                    onPaginationModelChange={(newPaginationModel) => {
                      setEmployerData((prevState) => ({
                        ...prevState,
                        paginationModel: newPaginationModel,
                      }));
                    }}
                  />
                </Box>
              )}
            </Box>
          </>
        )}
      </Box>

      <DeleteConfirmationDialog
        open={dialog}
        onClose={() => setDialog(false)}
        onConfirm={handleDeleteConfirmation}
        pageName={"job"}
      />

      <AddJob
        open={editJobDialog}
        closePopup={() => setEditJobDialog(false)}
        data={jobData}
        jobId={jobId}
      />
      <CustomSnackbar
        open={snackbar.open}
        message={snackbar.message}
        severity={snackbar.severity}
        onClose={() => setSnackbar({ open: false, message: "", severity: "" })}
      />
      <ShortlistedDialog
        open={shortlistedDialog}
        close={closeShortlistedDialog}
        candidateData={candidateData}
        sourceType={sourceType}
        tabValue={tabValue}
        setTabValue={setTabValue}
        candidateId={shortlistId}
        jobId={jobId}
        shortlisted={true}
        fetchCandidateData={fetchCandidateData}
        questionsData={questionsData}
        title={jobData?.basicDetails?.["Job Title"]}
        dateModified={dateModified}
        currentStatus={status}
        fetchJobShortlistedDetails={fetchJobShortlistedDetails}
        fetchJobApplicantsDetails={fetchJobApplicantsDetails}
      />
    </Box>
  );
}
